<template>
  <el-form :model="formData" label-width="150px" style="margin-top: 10px">
    <el-form-item label="打印模板：">
      <el-select v-model="formData.template_id" @change="templateChange" class="form-item" placeholder="请选择打印模板" clearable>
        <el-option v-for="template in templates" :key="template.id" :label="template.name" :value="template.id"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="item.label" v-for="item in formItems" :key="item.dataKey">
      <el-input v-model="formData[item.dataKey]" :placeholder="item.placeholder" class="form-item"></el-input>
    </el-form-item>

    <div id="divPrint" class="preview-img" :style="'width:' + imageWidth + 'px; height:' + imageHeight + 'px;'">
      <img :src="imageBase64" :style="'width:' + imageWidth + 'px; height:' + imageHeight + 'px;'" v-if="imageBase64.length > 0">
    </div>

    <el-form-item>
      <el-button @click="postPrint" :loading="loading">打印</el-button>
      <el-button @click="webPrint('item','tag')" :loading="loading">网页端打印测试</el-button>
      <el-button @click="postPreview" :loading="loading">预览</el-button>
      <KfMessage ref="commitMessage"></KfMessage>
    </el-form-item>
  </el-form>
</template>

<script>

export default {
  name: "FormPrint",
  emits: ['submitted'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        template_id: ''
      },
      templates: [],
      formItems: [],
      bomList: [],
      imageBase64: '',
      imageHeight: 400,
      imageWidth: 500,
      printDto: {},
      loading: false
    }
  },
  created() {
    this.loadTemplates()
  },
  methods: {
    loadTemplates() {
      console.log("loadTemplates in")
      this.$axios.get('bus/print/getFormTemplates').then(response => {
        this.loading = false;
        let res = response.data
        if (res.code != 0) {
          return this.$message.error(`获取打印模板失败，${res.message}`);
        }
        this.templates = res.data || []
      }, error => {
        this.$message.error(`获取打印模板失败，${error.message}`);
      })
    },
    templateChange() {
      this.imageBase64 = ''

      if (!this.formData.template_id || this.formData.template_id.length == 0) {
        this.formItems = []
        return;
      }

      for (var i = 0; i < this.templates.length; i++) {
        if (this.templates[i].id == this.formData.template_id) {
          this.formItems = this.templates[i].formItems;
          return;
        }
      }
    },
    async postPreview() {
      if (!this.formData.template_id || this.formData.template_id.length == 0) {
        this.$message.error('请选择打印模板');
        return;
      }

      this.loading = true;
      await this.$axios.post('bus/print/createPrintDto', this.formData).then(response => {
        this.loading = false;
        let res = response.data

        this.printDto = res.data;
        this.imageBase64 = res.data.imageBase64 || '';

        if (this.imageBase64.length > 0) {
          this.imageBase64 = "data:image/jpeg;base64," + this.imageBase64;
        }
      }, error => {
        this.loading = false;
        this.$refs.commitMessage.showError(`生成打印图像失败，${error.message}`);
      })
    },
    async postPrint() {
      await this.postPreview();

      console.log(this.printDto)

      if (!this.imageBase64 || this.imageBase64.length == 0) {
        return;
      }

      this.loading = true;
      //调用本地打印服务器
      this.$axios.post(process.env.VUE_APP_PRINT_URL, this.printDto).then(response => {
        this.loading = false;
        let res = response.data

        console.log(res)


      }, error => {
        this.loading = false;
        this.$refs.commitMessage.showError(`提交打印失败，${error.message}`);
      })
    },
    async webPrint(type, name) {
      /*if ("item" == type && this.formData.sn.length == 0) {
        this.$message.error('请选择输入SN');
        return;
      }

      if ("box" == type && this.formData.box_no.length == 0) {
        this.$message.error('请选择输入箱号');
        return;
      }*/

      if ("template" == type && this.formData.template_id.length == 0) {
        this.$message.error('请选择打印模板');
        return;
      }

      this.formData.type = type;
      this.formData.name = name;

      this.loading = true;
      // xgb 20220719
      // 这里加await等待调用完毕，否则postPrint会出问题
      await this.$axios.post('bus/print/createPrintDto', this.formData).then(response => {
        this.loading = false;
        let res = response.data

        if (res.code != 0) {
          return this.$refs.commitMessage.showError(`提交失败，${res.message}`);
        }
        this.printDto = res.data;
        this.imageBase64 = res.data.imageBase64 || '';
        console.log("imageBase64=" + this.imageBase64);

        if (this.imageBase64.length > 0) {
          this.imageBase64 = "data:image/jpeg;base64," + this.imageBase64;
          this.imageWidth = res.data.width;
          this.imageHeight = res.data.height;
        }
      }, error => {
        this.loading = false;
        this.$refs.commitMessage.showError(`生成打印图像失败，${error.message}`);
      })

      //调用打印
      if (this.imageBase64.length > 0) {
        //调用打印,等待100毫秒
        //setTimeout(this.printDiv, 2000);
        this.printDiv();
      }
    },

    printDiv() {
      //打印div
      //打开一个新窗口newWindow
      var newWindow = window.open("打印窗口", "_blank");
      //要打印的div的内容
      var docStr = document.getElementById("divPrint").innerHTML;
      //打印内容写入newWindow文档
      newWindow.document.write(docStr);
      //关闭文档
      newWindow.document.close();

      //调用打印机
      setTimeout(() => {
        newWindow.print();
        newWindow.close();
      }, 50);

      return false;
    }
  }
}
</script>

<style scoped>
.form-item {
  width: 250px;
}

.preview-img {
  position: absolute;
  top: 20px;
  left: 460px;
  width: 502px;
  height: 402px;
  border: 1px solid gray;
}

.trouble-box {
  padding-top: 10px;
  margin-bottom: 20px;
  position: relative;
}

.trouble-box .del {
  position: absolute;
  top: 0px;
  right: 15px;
  cursor: pointer;
  font-size: 24px;
}

.close {
  position: absolute;
  top: -10px;
  right: 5px;
  font-size: 18px;
  cursor: pointer;
}

.tip {
  color: goldenrod;
}
</style>